import { render } from "./LegalVersionPublishModal.vue?vue&type=template&id=f8ffe266&scoped=true"
import script from "./LegalVersionPublishModal.vue?vue&type=script&lang=js"
export * from "./LegalVersionPublishModal.vue?vue&type=script&lang=js"

import "./LegalVersionPublishModal.vue?vue&type=style&index=0&id=f8ffe266&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8ffe266"]])

export default __exports__